export default "__VITE_ASSET__CisjbQ4r__"